<script setup lang="ts">
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
interface Props {
  loading?: boolean
  text?: string
  icon?: string
  block?: boolean
  variant?: string
  to?: string
  size?: ButtonSize
  brandColor?: string
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  text: 'Submit',
  icon: '',
  block: false,
  variant: 'primary',
  to: undefined,
  size: 'md',
  brandColor: undefined
})
const buttonStyles = computed(() => {
  if (!props.brandColor) return {}
  if (props.variant === 'ghost') {
    return {
      color: props.brandColor
    }
  }
  return {
    backgroundColor: props.brandColor,
    color: '#fff'
  }
})
const buttonClasses = computed(() => {
  const baseClasses = ['text-center']
  if (props.brandColor) {
    return baseClasses
  }
  return [
    ...baseClasses,
    props.variant === 'ghost' ? '!text-primary-700 hover:!bg-primary-50' : '!bg-primary-600 !text-white hover:!bg-primary-700'
  ]
})
</script>
<template>
  <Button type="submit" :to="props.to" color="primary" :variant="props.variant === 'ghost' ? 'ghost' : 'solid'"
    :loading="props.loading" :block="props.block" :size="props.size" :class="buttonClasses" :style="buttonStyles">
    <template v-if="props.icon" #leading>
      <Icon :name="props.icon" />
    </template>
    {{ props.text }}
  </Button>
</template>